import React from 'react';
import { STRINGS } from 'constants/strings.constant';
import { ProjectStatusFilter, StatusFilterPillsProps } from 'interfaces/project.interface';
import './status_filter_pills.ui.scss';

const PILLS: ProjectStatusFilter[] = ['all', 'live', 'ready', 'needs'];

const StatusFilterPills = (props: StatusFilterPillsProps) => {
  const { counts, value, onChange } = props;

  const labelOf = (key: ProjectStatusFilter): string =>
    key === 'all' ? STRINGS.project.filter.all : STRINGS.project.status[key];

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>, index: number) => {
    const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (!step) return;
    e.preventDefault();
    onChange(PILLS[(index + step + PILLS.length) % PILLS.length]);
  };

  return (
    <div className="status_filter_pills" role="tablist" aria-label={STRINGS.project.filter.ariaLabel}>
      {PILLS.map((key, index) => {
        const isActive = key === value;
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive ? 0 : -1}
            className={`status_filter_pill${isActive ? ' status_filter_pill--active' : ''}`}
            onClick={() => !isActive && onChange(key)}
            onKeyDown={(e) => handleKeyDown(e, index)}>
            {key !== 'all' && (
              <span className={`status_filter_pill_dot status_filter_pill_dot--${key}`} aria-hidden="true" />
            )}
            <span className="status_filter_pill_label">{labelOf(key)}</span>
            <span className="status_filter_pill_count">{counts[key]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default StatusFilterPills;
